import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getOutgoingTCs = createAsyncThunk(
  "getOutgoingTCs",
  async (companyId) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error.message);
    }
  }
);

export const getIncomingTCs = createAsyncThunk("getIncomingTCs", async () => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/tc?shipmentStatus=INCOMING`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {}
});

export const getApprovedShipments = createAsyncThunk(
  "getApprovedShipments",
  async (buyerId) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc?buyerId=${buyerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {}
  }
);

export const getReturnedTCs = createAsyncThunk("getReturnedTCs", async () => {
  const token = localStorage.getItem("cu_user");
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/tc?status=PENDING&stage=CLIENT`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {}
});

export const getTCDetails = createAsyncThunk("getTCDetails", async (tcId) => {
  const token = localStorage.getItem("cu_user");
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/tc/${tcId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {}
});

export const acceptIncomingTC = createAsyncThunk(
  "acceptIncomingTC",
  async (id) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/shipment/approveShipment/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "Success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Incoming Shipment Accepted successfully",
        error: {
          render({ data }) {
            return `${data.message}`;
          },
        },
      }
    );
  }
);

export const rejectIncomingTC = createAsyncThunk(
  "rejectIncomingTC",
  async (id) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/shipment/reject/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Incoming Shipment rejected successfully",
        error: {
          render({ data }) {
            return `${data.message}`;
          },
        },
      }
    );
  }
);

export const countsForTCClient = createAsyncThunk(
  "countsForTCClient",
  async () => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc/agg-status/count`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const TransactionCertificateSlice = createSlice({
  name: "transactionCertificateClient",
  initialState: {
    outgoingTCs: [],
    incomingTCs: [],
    returnedTCs: [],
    approvedShipments: [],
    TC: [],
    counts: [],
    status: "idle",
    isloading: true,
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getOutgoingTCs.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getOutgoingTCs.fulfilled]: (state, action) => {
      state.status = "success";
      state.outgoingTCs = action.payload;
      state.isloading = false;
    },
    [getOutgoingTCs.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [getIncomingTCs.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingTCs.fulfilled]: (state, action) => {
      state.status = "success";
      state.isloading = false;
      state.incomingTCs = action.payload;
    },
    [getIncomingTCs.rejected]: (state, action) => {
      state.status = "failed";
      state.isloading = true;
      state.error = action.error;
    },
    [getTCDetails.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getTCDetails.fulfilled]: (state, action) => {
      state.status = "success";
      state.TC = action.payload;
      state.isloading = false;
    },
    [getTCDetails.rejected]: (state, action) => {
      state.status = "failed";
      state.isloading = true;
      state.error = action.error;
    },

    [getReturnedTCs.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getReturnedTCs.fulfilled]: (state, action) => {
      state.status = "success";
      state.returnedTCs = action.payload;
      state.isloading = false;
    },
    [getReturnedTCs.rejected]: (state, action) => {
      state.status = "failed";
      state.isloading = true;
      state.error = action.error;
    },
    [countsForTCClient.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [countsForTCClient.fulfilled]: (state, action) => {
      state.status = "success";
      state.counts = action.payload.data;
      state.isloading = false;
    },
    [countsForTCClient.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [getApprovedShipments.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getApprovedShipments.fulfilled]: (state, action) => {
      state.status = "success";
      state.approvedShipments = action.payload.data;
      state.isloading = false;
    },
    [getApprovedShipments.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
  },
});

export default TransactionCertificateSlice.reducer;
